import axios from "axios";

import {tokenService,userService} from '@/services'
import store from '@/store'

const instance = axios.create({
  baseURL : store.getters.getApiAdress,
  headers: {
    "Content-Type": "application/json",
  },
});


/**
 * Intercepteur pour injectopn du token
 */
instance.interceptors.request.use((request) => {
  try {
    const token = tokenService.getToken();
    if (!token) { throw new Error("Token invalid"); } 
    else {
      request.headers["Authorization"] = 'Bearer ' + token;
      return request;
    }
  } catch (_error) {
    if(!tokenService.isTokenValid()) userService.logout();
    return Promise.reject(_error);
  }
},
(error) => {
    return Promise.reject(error);
});


/**
 * Intercepteur des reponses de l'api
 */
instance.interceptors.response.use(response => {
  //console.log(' ---- Intercepteur reponse OK');
  if(response.statusText == 'OK') {
    const errorFr = response.data.addons?.errorFr
    if(errorFr!=="") {
      console.log(errorFr);
      //alert(' ---- Intercepteur reponse avec une erreur '+errorFr);
      return Promise.reject(errorFr);
    }
    const refreshToken = response.data?.refreshToken
    tokenService.updateLocalAccessToken(refreshToken);
    if(refreshToken){
      const cloneResponse = { ...response }; //Cloner la reponse
      if(delete cloneResponse.data.refreshToken) {
        return cloneResponse
      }
      return response
    }
  }
  return response
}, error => {
  console.log('interceptors.response.error');
  console.log(error);
  if(!tokenService.isTokenValid()) userService.logout();
  return Promise.reject(error);
});

export default instance;